"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_POI_DISTANCE = void 0;
var DEFAULT_POI_DISTANCE = {
  subway: {
    lte: 400
  },
  electric_charging: {
    lte: 400
  }
};
exports.DEFAULT_POI_DISTANCE = DEFAULT_POI_DISTANCE;